export default (types, initial = {}) => (state = initial, { type, ...action }) => type in types
  ? types[type](state, action)
  : state;
